export default "__VITE_ASSET___ekrYssC__"